import { render, staticRenderFns } from "./CourseCodDeposits.vue?vue&type=template&id=840ecb8e&"
import script from "./CourseCodDeposits.vue?vue&type=script&lang=js&"
export * from "./CourseCodDeposits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports